import { gql } from "@edreamsodigeo/frontend-api-client";

export const GET_MEMBERSHIP = gql`
  query GetMembership($membershipRequest: MembershipRequest) {
    membership(membershipRequest: $membershipRequest) {
      name
      lastNames
      autoRenewalStatus
      expirationDate
      type
      isFreeTrial
      renewalPrice {
        amount
        currency
      }
      isAutoApply
      status
      recurringCollectionId
    }
  }
`;
